import { actionTypes } from '@/core/constants'
import api from '@/core/apiclient'
import DownloadFile from '@/core/utils/DownloadFile'

export default {
	async [actionTypes.PEDIDO.DOCUMENTO.BAIXAR_DOCUMENTO_PEDIDO](context, idDocumento) {
		const response = await api.documentosPedido.baixar(idDocumento)
		const headers = response.headers

		DownloadFile.downloadArrayBuffer(response.data, headers.filename, headers['content-type'], headers.extension)
	},
}
